import {ImageRequestParams} from "../../models/image/image-request-params";

export class InvitationBackgroundImageRequestParams extends ImageRequestParams {
  constructor() {
    super({});

    this._resourceName = `bolao26/assets/Desktop_Invitation_BG.png`;
  }
}
